import '../../components/tabs-talentech/tabsTalentech';
import '../../components/badge-talentech/badgeTalentech';
import '../../components/input-talentech/inputTalentech';
import '../../components/filters-talentech/filtersTalentech';

// Talentech components
const talentechComponents = require.context('../../components', true, /dist.js$/);
export const ignoredElements = talentechComponents.keys().map((e) => e.split('/')[1]);
